function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 132,
  height: 59
}, /*#__PURE__*/React.createElement("rect", {
  width: 132,
  height: 59,
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.9168 23.3752C80.7504 41.5416 51.2496 41.5416 33.0832 23.3752L16.6248 6.91681C-1.54161 -11.2496 -1.54161 -40.7503 16.6248 -58.9168L45.5 -87.792C63.6664 -105.958 93.1671 -105.958 111.334 -87.792L127.792 -71.3336C145.958 -53.1671 145.958 -23.6664 127.792 -5.49999L98.9168 23.3752Z",
  stroke: "#EEE294",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: -105,
  y: -49.337,
  width: 186.2,
  height: 186.2,
  rx: 57,
  transform: "rotate(-45 -105 -49.337)",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.6348 25.4386C46.8028 25.9478 47.035 27.156 46.9189 28.2123C46.0413 36.2204 39.2479 42.46 31.0075 42.46C22.173 42.46 15 35.2869 15 26.4525C15 20.2085 18.5843 14.7931 23.8032 12.1557C26.4987 10.7934 32.2894 9.91364 35.753 13.8105C38.4395 16.832 38.8438 21.9794 34.2323 26.5864C33.6517 27.214 33.0464 27.7991 32.2424 28.5495C32.2424 28.5495 33.339 29.6571 33.9553 30.2489C35.6481 31.8367 38.6584 31.6982 40.0787 30.0233C41.2132 28.6856 41.9255 27.8215 42.8098 26.5307C43.6204 25.3471 44.8979 25.1193 45.6348 25.4386ZM30.9985 29.5164L31.1103 29.637C31.1103 29.637 29.5649 28.0917 28.1736 26.7004C26.7444 25.2712 24.4264 25.2712 22.9971 26.7004C22.5192 27.1805 22.0457 27.654 21.6505 28.0492C21.3825 28.315 21.2328 28.6768 21.2328 29.0542C21.2328 29.4294 21.3825 29.7912 21.6505 30.0592C22.1686 30.5773 24.4642 32.8304 26.6304 34.9542C29.049 37.3392 32.9348 37.3303 35.3444 34.9363C36.5704 33.8019 37.6289 32.8082 37.8701 32.5424C36.4989 33.2593 34.2144 32.7321 32.7561 31.2917C32.1666 30.7022 31.5814 30.1104 30.9985 29.5164Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 29.8453,
  y1: 67.7782,
  x2: -136.054,
  y2: 62.1541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333785"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#484CAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#3F6EB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#349DC5"
})));

function SvgMenuHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 59,
    viewBox: "0 0 132 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHeaderLogo);
export default __webpack_public_path__ + "static/media/menu-header-logo.2476324d.svg";
export { ForwardRef as ReactComponent };